// @alamo/ui · Phase 02.3.3 P01.T2 · D-21 justificativa obrigatória
// Props pattern consistent with Input (label/required/error/htmlFor binding).

import * as React from 'react';

import { cn } from '../../lib/cn';

export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  required?: boolean;
  error?: string;
  rows?: number;
}

export const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(function Textarea(
  { label, required, error, rows = 3, id, className, ...props },
  ref,
) {
  const generatedId = React.useId();
  const inputId = id || generatedId;
  const errorId = error ? `${inputId}-error` : undefined;
  return (
    <div className="flex w-full flex-col gap-1">
      {label && (
        <label htmlFor={inputId} className="mb-2 block text-sm font-medium text-secondary-950">
          {label}
          {required && (
            <span className="text-error-500 ml-1" aria-hidden="true">
              *
            </span>
          )}
        </label>
      )}
      <textarea
        ref={ref}
        id={inputId}
        rows={rows}
        aria-describedby={errorId}
        aria-invalid={error ? true : undefined}
        className={cn(
          'w-full rounded-md border border-slate-300 px-3 py-2 text-sm font-body',
          'focus:outline-none focus:ring-2 focus:ring-primary-500',
          error && 'border-error-500',
          className,
        )}
        {...props}
      />
      {error && (
        <p id={errorId} className="mt-1 text-xs text-error-600" role="alert">
          {error}
        </p>
      )}
    </div>
  );
});
